import {
    USER_ANALYTICS_TRACKER_DELETE,
    USER_ANALYTICS_TRACKER_UPDATE,
    USER_ANALYTICS_SET,
} from './userAnalyticsConstants';
import {
    MNUserAnalyticsTracker,
    MNUserAnalyticsTrackerState,
    PendingEvent,
    UserAnalyticsTrackerType,
} from './userAnalyticsTypes';

export const updateUserAnalyticsTracker = ({
    pendingEvent,
    trackerType,
    state,
}: {
    pendingEvent?: PendingEvent;
    trackerType: UserAnalyticsTrackerType;
    state?: MNUserAnalyticsTrackerState;
}) => ({
    type: USER_ANALYTICS_TRACKER_UPDATE,
    pendingEvent,
    trackerType,
    state,
    sync: true,
});

export const removeUserAnalyticsTracker = ({ trackerType }: { trackerType: UserAnalyticsTrackerType }) => ({
    type: USER_ANALYTICS_TRACKER_DELETE,
    trackerType,
    sync: true,
});

export const setUserAnalytics = ({ analytics }: { analytics?: MNUserAnalyticsTracker[] }) => ({
    type: USER_ANALYTICS_SET,
    analytics,
});
